import classification from '@/common/classification';

export default {
  install(Vue: any) {
    Vue.prototype.$cls = classification;
  }
};
